import {createContext, useContext, useState} from "react";
import AppConfigContext from "./AppConfigContext";
import Service from "../rest/jtmc/models/Service";

export const ServiceContext = createContext({} as ServicesContextValues);

type ServicesContextValues = {
    setServices: (services: Service[]) => void,
    services: Service[],
    request: (s: Service) => void
}

export function ServiceProvider({children}: any) {
    const [services, setServices] = useState<Service[]>([]);

    const fetchContext = useContext(AppConfigContext).fetch;
    const snack = useContext(AppConfigContext).snackBarData?.events?.success;

    const request = (s:Service)=>{
        fetchContext.Menu.requests.requestService(s).then(()=>{
            if(snack != undefined)
                snack("درخواست با موفقیت اعلام شد")
        });
    }

    const set = (s:Service[])=>{
        setServices(s);
    }

    return <ServiceContext.Provider value={{
        setServices: set,
        services: services,
        request: request
    }}>
        {children}
    </ServiceContext.Provider>
}
